var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpiredManagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#343A3F",
    fillOpacity: 0.05
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3893_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.375 30.2656V32.375H34.4844M31.0814 27.5067L24.3708 15.4274C24.1308 14.9954 23.6698 14.7031 23.1406 14.7031C22.6114 14.7031 22.1505 14.9954 21.9105 15.4274L14.8792 28.0837C14.7634 28.2923 14.7027 28.527 14.7031 28.7656C14.7031 29.5423 15.3327 30.1719 16.1094 30.1719H27.833M23.1406 20.3281V23.1406",
    stroke: "#343A3F",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.375 37.2969C35.0933 37.2969 37.2969 35.0933 37.2969 32.375C37.2969 29.6567 35.0933 27.4531 32.375 27.4531C29.6567 27.4531 27.4531 29.6567 27.4531 32.375C27.4531 35.0933 29.6567 37.2969 32.375 37.2969Z",
    stroke: "#343A3F",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3893_35"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiredManagement);
export default __webpack_public_path__ + "static/media/expiredManagement.def312e4f325b0e277eb6627dc2b92c4.svg";
export { ForwardRef as ReactComponent };